import { SeatCharacteristic as SeatCharacteristicEnum } from '@eti/schema-types';
const iconMap = {
  [SeatCharacteristicEnum.LegSpace]: 'extralegroom',
  [SeatCharacteristicEnum.FrontOfCabin]: 'frontrow',
  [SeatCharacteristicEnum.EconomyComfort]: 'economy',
  [SeatCharacteristicEnum.Normal]: 'default',
  BASSINET: '',
  BULKHEAD: '',
  ELECTRONIC_CONNECTION: '',
  NOT_SUITABLE_FOR_CHILDREN: '',
  NO_INFANT_ALLOWED: '',
  SUITABLE_FOR_ADT_WITH_INF: ''
};
export const getSeatIconComponent = async (brand, characteristic, isSelected) => {
  var _iconMap, _await$tryLoadIcon;
  const key = isSelected ? 'selected' : (_iconMap = iconMap[characteristic]) !== null && _iconMap !== void 0 ? _iconMap : 'default';
  const tryLoadIcon = async (brandPath, fileKey) => {
    try {
      const iconModule = await import(`@eti/assets/icons/seating-buttons/${brandPath}/seatButton-${fileKey}.svg`);
      return iconModule.ReactComponent;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`Failed to load seat icon for brand: ${brandPath}, fileKey: ${fileKey}`, e);
      return null;
    }
  };
  return (_await$tryLoadIcon = await tryLoadIcon(brand, key)) !== null && _await$tryLoadIcon !== void 0 ? _await$tryLoadIcon : await tryLoadIcon('default', key);
};
//# sourceMappingURL=getSeatIconComponent.js.map